import i18n from 'i18next';
import React, { useEffect } from 'react';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend, { HttpBackendOptions } from 'i18next-http-backend';
import { initReactI18next, I18nextProvider, useTranslation } from 'react-i18next';

const languages: string[] = ['en'];

i18n.use(HttpBackend).use(LanguageDetector).use(initReactI18next).init<HttpBackendOptions>({
	debug: false,
	ns: ['common'],
	fallbackLng: 'en',
	supportedLngs: languages,
	nonExplicitSupportedLngs: false,
	detection: {
		order: ['localStorage', 'navigator'],
		caches: ['localStorage'],
		lookupLocalStorage: 'lang',
	},
	interpolation: {
		escapeValue: false,
	},
	backend: {
		loadPath: '/locales/{{lng}}/{{ns}}.json',
		requestOptions: {
			mode: 'cors',
			credentials: 'same-origin',
			cache: 'default',
		},
	},
});

export const TranslationProvider: React.FunctionComponent<{ children: React.ReactNode }> = ({ children }) => {
	const { i18n } = useTranslation();
	useEffect(() => {
		const lang = i18n.resolvedLanguage || i18n.language;
		if(!lang) return document.documentElement.removeAttribute('lang');
		document.documentElement.setAttribute('lang', lang);
	}, [i18n, i18n.resolvedLanguage]);

	return (
		<React.Suspense>
			<I18nextProvider i18n={i18n} defaultNS={'common'}>
				{children}
			</I18nextProvider>
		</React.Suspense>
	)
}
